<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col lg="9">
        <b-card >
          <div slot="header">Inventory Group/Category (Accounting)  
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="tblData.items"
            :fields="tblFields"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(nomor)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template>
            <template v-slot:cell(kodeacc_bekas)="data">
              {{ data.item.kodeacc_bekas}} {{ data.item.namaacc_bekas}}
            </template>
            <template v-slot:cell(kodeacc_rusak)="data">
              {{ data.item.kodeacc_rusak}} {{ data.item.namaacc_rusak}}
            </template>
            <template v-slot:cell(kodeacc_cogs)="data">
              {{ data.item.kodeacc_cogs}} {{ data.item.namaacc_cogs}}
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
        </b-col>
    </b-row>

    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8" lg="6">
        <b-card >
            <div slot="header">Inventory Category - Add/Edit Form 
              <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
              </div>
            </div>
            <b-input-group >
                <b-input-group-prepend><label>Inventory Account#</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.kodeacc" :state="!$v.frmdata.kodeacc.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuCoa('kodeacc')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-input-group-append><span class="input-group-text"> BRAND NEW</span></b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label class="text-right">Inventory Acc.Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.namaacc" :state="!$v.frmdata.namaacc.$error"></b-form-input>
            </b-input-group>

            <b-input-group >
                <b-input-group-prepend><label>Inventory Account#</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.kodeacc_bekas" :state="!$v.frmdata.kodeacc_bekas.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuCoa('kodeacc_bekas')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-input-group-append><span class="input-group-text"> USED/RECONDITION</span></b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label class="text-right">Inventory Acc.Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.namaacc_bekas" :state="!$v.frmdata.namaacc_bekas.$error"></b-form-input>
            </b-input-group>

            <b-input-group >
                <b-input-group-prepend><label>Inventory Account#</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.kodeacc_rusak" :state="!$v.frmdata.kodeacc_rusak.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuCoa('kodeacc_rusak')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-input-group-append><span class="input-group-text"> BROKEN/UN-SERVICEABLE</span></b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label class="text-right">Inventory Acc.Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.namaacc_rusak" :state="!$v.frmdata.namaacc_rusak.$error"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Inv.Usage Account#</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.kodeacc_cogs" :state="!$v.frmdata.kodeacc_cogs.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuCoa('kodeacc_cogs')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-input-group-append><span class="input-group-text"> COST</span></b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label class="text-right">Inv.Usage Acc.Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.namaacc_cogs" :state="!$v.frmdata.namaacc_cogs.$error"></b-form-input>
            </b-input-group>

          <!-- <b-input-group>
            <b-input-group-prepend><label>Inventory Usage-Type </label></b-input-group-prepend>
              <div style="flex: 1 1 auto;width: 1%;" >
                <b-form-radio-group class="mt-2" v-model="frmdata.invUsageType" name="radioLabel">
                  <b-form-radio :value="'FIXED ASSET'">FIXED ASSET</b-form-radio>
                  <b-form-radio :value="'REUSEABLE'">REUSEABLE</b-form-radio>
                  <b-form-radio :value="'CONSUMABLE'">CONSUMABLE </b-form-radio>
                </b-form-radio-group>
              </div>
          </b-input-group>           -->

        </b-card>
      </b-col>
    </b-row>
    
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import invcategory from "../../apis/logistic_inv_category";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        namaacc: { required },
        kodeacc: { required },
        namaacc_bekas: { required },
        kodeacc_bekas: { required },
        namaacc_rusak: { required },
        kodeacc_rusak: { required },
        namaacc_cogs: { required },
        kodeacc_cogs: { required },
        // invUsageType:  { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'invenDbAcc',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{inven_catid: '', kodeacc:'', invenDbAcc: '',invenCrAcc: '' , headcategory:'', invUsageType:'CONSUMABLE'},
      headcategories:[],
      tblData: {
        items: [],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
    };
  },
  components: {lkuCoa},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "kodeacc",
            label: "Account#",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Name",
            sortable: true
          },
          {
            key: "kodeacc_bekas",
            label: "Account# USED/RECONDITION",
            sortable: true
          },
          {
            key: "kodeacc_rusak",
            label: "Account# BROKEN/UNSERVICEABLE",
            sortable: true
          },
          {
            key: "kodeacc_cogs",
            label: "Account# COST (InventoryUsage)",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
      this.data();
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      const list = await invcategory.list(this.tblData);      
      this.tblData.items= list;
    },
    refresh(ctx) {
      // if (this.$refs.table) this.$refs.table.refresh();
      this.data();
    },
    clearFilter(ctx) {
        this.tblData.namaacc=  '';
        this.tblData.kodeacc=  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await invcategory.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                // this.saveEnabled=true;
                // this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
        await invcategory.remove(this.model);
        this.refresh();
      } catch (error) {
          // this.saveEnabled=true;
          // this.isLoading=false;
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
          switch (this.lkuCoaCaller) {
            case 'kodeacc':
                this.frmdata.kodeacc = _selected.kodeacc;
                this.frmdata.namaacc = _selected.namaacc;              
              break;
          
            case 'kodeacc_bekas':
                this.frmdata.kodeacc_bekas = _selected.kodeacc;
                this.frmdata.namaacc_bekas = _selected.namaacc;              
              break;

            case 'kodeacc_rusak':
                this.frmdata.kodeacc_rusak = _selected.kodeacc;
                this.frmdata.namaacc_rusak = _selected.namaacc;              
              break;

            case 'kodeacc_cogs':
                this.frmdata.kodeacc_cogs = _selected.kodeacc;
                this.frmdata.namaacc_cogs = _selected.namaacc;              
              break;

            default:
              break;
          }
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
